import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'relements/build/esm/ui/icon';
import Button from 'relements/build/esm/ui/button';
import Accordion from 'relements/build/esm/ui/accordion';
import Drawer from 'relements/build/esm/overlays/drawer';
import Checkbox from 'relements/build/esm/input/checkbox';

import { FILTERS } from '../../const';
import styles from './FilterDrawer.scss';

function FilterDrawer({
  active,
  onClose,
  value,
  onChange,
  onClear,
  onApply,
  filtersChanged,
}) {
  const [activeIndex, setActiveIndex] = React.useState([0]);
  const handleChange = React.useCallback((key, options) => val => {
    const oldValue = value[key] || [];
    const newValue = val || [];
    const allWasSelected = !!oldValue.filter(val => val.title === 'All').length;
    const allWillBeSelected = !!newValue.filter(val => val.title === 'All')
      .length;

    // We need to handle the All checkbox item that's not really a filter
    // If All is checked, then all the other filters should also be selected
    // If All is unchecked, then all the other filter should also be unselected
    // If all the filters are selected, then the All checkbox should also be selected
    if (allWasSelected !== allWillBeSelected && allWillBeSelected) {
      // ALL SELECTED, select all elements
      onChange({ ...value, [key]: options });
    } else if (allWasSelected !== allWillBeSelected && !allWillBeSelected) {
      // ALL DESELECTED, deselect all elements
      onChange({ ...value, [key]: [] });
    } else if (options.length === val.length + 1 && !allWasSelected) {
      // NEW VALUE SHOULD HAVE ALL VALUES SELECTED, add all
      onChange({ ...value, [key]: options });
    } else if (options.length !== val.length) {
      // NEW VALUE DOESNT HAVE ALL VALUES SELECTED, remove all
      onChange({ ...value, [key]: val.filter(item => item.title !== 'All') });
    } else {
      onChange({ ...value, [key]: val });
    }
  });

  return (
    <Drawer
      className={styles.filterDrawer}
      position="LEFT"
      noOverlay
      active={active}
      attachTo="find-replace"
      zIndex={1}
      width={260}
    >
      <br />
      <br />
      <br />
      <Drawer.Header>
        <span className={styles.filterDrawerHeader}>
          FILTER BY
          <Icon onClick={onClose} src="close" />
        </span>
      </Drawer.Header>
      <div className={styles.filterDrawerBody}>
        <Accordion>
          {FILTERS.map((filter, i) => {
            const filterValue = value[filter.key] || [];
            return (
              <Accordion.Item
                key={i}
                itemIndex={i}
                active={activeIndex.includes(i)}
                className={styles.filterDrawerItem}
                onChange={index => {
                  setActiveIndex(
                    activeIndex.includes(index)
                      ? activeIndex.filter(j => index !== j)
                      : activeIndex.concat([index])
                  );
                }}
                renderHeader={() => (
                  <span className={styles.filterDrawerItemHeader}>
                    <Icon
                      src="angle-down"
                      className={`${styles.filterDrawerItemHeaderIcon} ${
                        activeIndex.includes(i) ? styles.active : ''
                      }`}
                    />
                    {filter.title}
                  </span>
                )}
              >
                <Checkbox
                  value={filterValue}
                  options={filter.options}
                  optionKey="title"
                  onChange={handleChange(filter.key, filter.options)}
                  className={styles.filterDrawerItemBody}
                />
              </Accordion.Item>
            );
          })}
        </Accordion>
      </div>
      <div className={styles.filterDrawerFooter}>
        <Button onClick={onClear}>Clear</Button>
        <Button
          disabled={!filtersChanged}
          onClick={onApply}
          type={Button.TYPES.OUTLINE}
        >
          Apply Filters
        </Button>
      </div>
    </Drawer>
  );
}

FilterDrawer.propTypes = {
  active: PropTypes.bool,
  onChange: PropTypes.func,
  onClear: PropTypes.func,
  onApply: PropTypes.func,
  onClose: PropTypes.func,
  filtersChanged: PropTypes.bool,
  value: PropTypes.shape({}),
};

FilterDrawer.defaultProps = {
  active: false,
  filtersChanged: false,
  onChange: () => {},
  onClose: () => {},
  onClear: () => {},
  onApply: () => {},
  value: {},
};

export default FilterDrawer;
